























































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import { ConfirmAccountDto, ConfirmAccountModel } from 'admiral-core';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormError from '@/components/common/forms/FormError.vue';

@Component({
  components: { FormError, FormInputPassword, FormInput, FormRow },
})
export default class ConfirmAccountForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: ConfirmAccountModel;

  @Prop({ required: true, type: Object })
  readonly errors!: ConfirmAccountModel;

  onInput(key: keyof ConfirmAccountDto, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: keyof ConfirmAccountDto) {
    this.$emit('resetError', key);
  }
}
